
import './App.css';
import Home from "./Pages/home.jsx"
import Privacy from './Section/privacy/Privacy.jsx';
import TnC from "./Section/TnC/TnC.jsx"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/termsandconditions" element={<TnC/>}/>
      </Routes>
    </Router>
  );
}

export default App;